import React, { useState } from "react";
import wordicon from "../../assets/ms_word.png";
import excelicon from "../../assets/ms_excel.png";
import pdficon from "../../assets/pdf.png";
import CustomSearchSortHeader from "../../components/core/CustomSearchSortHeader";
import JisTabButton from "../../components/controls/jisTabButton";
import JisButton from "../../components/controls/jisButton";
import Pagenated from "../../components/pagenated";
import JisEmptyList from "../../components/controls/emptylist";
import { displayDate } from "../../constants";

const postJudgmentCases = [
  {
    id: 1,
    suitNumber: "REF515802024",
    caseTitle: "Fundamental Human Rights",
    judgementDate: "12 Sept, 2025",
    judgeName: "Dadam",
    judgmentDebtor: "Salman Lukman",
    judgmentCreditor: "Lagos State",
  },
  {
    id: 2,
    suitNumber: "REF515802024",
    caseTitle: "Fundamental Human Rights",
    judgementDate: "12 Sept, 2025",
    judgeName: "Dadam",
    judgmentDebtor: "Salman Lukman",
    judgmentCreditor: "Lagos State",
  },
  {
    id: 3,
    suitNumber: "REF515802024",
    caseTitle: "Fundamental Human Rights",
    judgementDate: "12 Sept, 2025",
    judgeName: "Dadam",
    judgmentDebtor: "Salman Lukman",
    judgmentCreditor: "Lagos State",
  },
  {
    id: 4,
    suitNumber: "REF515802024",
    caseTitle: "Fundamental Human Rights",
    judgementDate: "12 Sept, 2025",
    judgeName: "Dadam",
    judgmentDebtor: "Salman Lukman",
    judgmentCreditor: "Lagos State",
  },
  {
    id: 5,
    suitNumber: "REF515802024",
    caseTitle: "Fundamental Human Rights",
    judgementDate: "12 Sept, 2025",
    judgeName: "Dadam",
    judgmentDebtor: "Salman Lukman",
    judgmentCreditor: "Lagos State",
  },
  {
    id: 6,
    suitNumber: "REF515802024",
    caseTitle: "Fundamental Human Rights",
    judgementDate: "12 Sept, 2025",
    judgeName: "Dadam",
    judgmentDebtor: "Salman Lukman",
    judgmentCreditor: "Lagos State",
  },
];

const cashierCases = [
  {
    id: 1,
    suitNumber: "REF515802024",
    caseTitle: "Fundamental Human Rights",
    judgementDate: "12 Sept, 2025",
    judgeName: "Dadam",
    judgmentDebtor: "Salman Lukman",
    judgmentCreditor: "Lagos State",
  },
  {
    id: 2,
    suitNumber: "REF515802024",
    caseTitle: "Fundamental Human Rights",
    judgementDate: "12 Sept, 2025",
    judgeName: "Dadam",
    judgmentDebtor: "Salman Lukman",
    judgmentCreditor: "Lagos State",
  },
  {
    id: 3,
    suitNumber: "REF515802024",
    caseTitle: "Fundamental Human Rights",
    judgementDate: "12 Sept, 2025",
    judgeName: "Dadam",
    judgmentDebtor: "Salman Lukman",
    judgmentCreditor: "Lagos State",
  },
  {
    id: 4,
    suitNumber: "REF515802024",
    caseTitle: "Fundamental Human Rights",
    judgementDate: "12 Sept, 2025",
    judgeName: "Dadam",
    judgmentDebtor: "Salman Lukman",
    judgmentCreditor: "Lagos State",
  },
  {
    id: 5,
    suitNumber: "REF515802024",
    caseTitle: "Fundamental Human Rights",
    judgementDate: "12 Sept, 2025",
    judgeName: "Dadam",
    judgmentDebtor: "Salman Lukman",
    judgmentCreditor: "Lagos State",
  },
  {
    id: 6,
    suitNumber: "REF515802024",
    caseTitle: "Fundamental Human Rights",
    judgementDate: "12 Sept, 2025",
    judgeName: "Dadam",
    judgmentDebtor: "Salman Lukman",
    judgmentCreditor: "Lagos State",
  },
];

export const LegalCounselPostJudgement = () => {
  const [tab, setTab] = useState("postJudgment");
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const currentCases =
    tab === "postJudgment" ? postJudgmentCases : cashierCases;

  const onPagePick = (pick) => {
    setPageIndex(pick.id - 1);
  };

  const onViewDetails = (caseId) => {
    console.log("View case details:", caseId);
  };

  const onSearch = () => {};

  return (
    <div>
      <CustomSearchSortHeader
        onSearch={onSearch}
        frequentData={{}}
        isSearchAndDateOnly
      />

      <div className="exportdiv">
        <img src={wordicon} style={{ cursor: "pointer" }} />
        <img src={excelicon} style={{ cursor: "pointer" }} />
        <img src={pdficon} style={{ cursor: "pointer" }} />
      </div>

      <div className="tab_section ds-tab-container">
        <JisTabButton
          isActive={tab == "postJudgment"}
          title="Post Judgment Cases"
          isRoleBased={false}
          onClick={() => setTab("postJudgment")}
        />
        <JisTabButton
          isActive={tab == "cashier"}
          title="Cashier Cases"
          isRoleBased={false}
          onClick={() => setTab("cashier")}
        />
      </div>

      <div className="tab_view">
        {currentCases?.length === 0 && <JisEmptyList />}
        {currentCases?.length > 0 && (
          <div className="table">
            <div className="section-cases">
              <span>
                {tab === "postJudgment"
                  ? "Post Judgment Cases"
                  : "Cashier Cases"}
              </span>
            </div>
            <div className="table-wrapper">
              <table className="case-table">
                <thead>
                  <tr>
                    <th className="col-title">Suit Number</th>
                    <th className="col-title">Case Title</th>
                    <th className="col-medium">Date of Judgment</th>
                    <th className="col-medium">Judge Name</th>
                    <th className="col-title">Judgment Debtor</th>
                    <th className="col-title">Judgment Creditor</th>
                    <th className="col-action">Proceed</th>
                  </tr>
                </thead>
                <tbody>
                  {currentCases?.map((caseItem, index) => (
                    <tr key={index}>
                      <td>{caseItem.suitNumber}</td>
                      <td>{caseItem.caseTitle}</td>
                      <td>{displayDate(caseItem.judgementDate)}</td>
                      <td>{caseItem.judgeName}</td>
                      <td>{caseItem.judgmentDebtor}</td>
                      <td>{caseItem.judgmentCreditor}</td>
                      <td>
                        <JisButton
                          variant="plain"
                          onClick={() => onViewDetails(caseItem.id)}
                        >
                          {tab === "postJudgment"
                            ? "Initiate Post Judgment Procedure"
                            : "Continue"}
                        </JisButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Pagenated
              onChangePageSize={(k) => setPageSize(k)}
              size={pageSize}
              total={currentCases.length}
              maxPage={20}
              onPick={onPagePick}
            />
          </div>
        )}
      </div>
    </div>
  );
};
